// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assests/stacking-cards.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assests/background-image/migration_pro.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.migration-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  margin-top: 3rem;
}

.migration-section-title {
  font-size: 50px;
  line-height: 80px;
  font-weight: 700;
  text-align: center;
}

.migration-section-para {
  font-size: 16px;
  letter-spacing: 0.4px;
  font-weight: 400;
  text-align: center;
}

.token-contain {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1.5rem;
  margin-top: 1.5rem;
}

.token-cards {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  width: 480px;
  border-radius: 20px;
  padding: 30px;
  box-shadow: 0 0 10px 0 #00000033;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.token-cards h4 {
  font-size: 30px;
  font-weight: 600;
  line-height: 40px;
  color: #234b9a;
}

.migration-cards-para {
  font-size: 18px;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.4px;
  color: #515151;
}

.migration-ratio {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  margin-top: 3rem;
}

.migrationRatio-cards {
  width: 375px;
  padding: 0 5px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.border-rht {
  border-right: 1px dotted #7c7c7c;
}

.migrationRatio-cards h2 {
  font-size: 31px;
  font-weight: 600;
  line-height: 48px;
}

.benefit-migra-wrapper {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  justify-content: center;
  align-items: center;
}

.benft-cards-contain {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4rem;
}
.benefit-crds {
  width: 85%;
  display: flex;
  gap: 2rem;
  padding: 16px;
  box-shadow: 0 0 10px 0 #00000033;
}

.benefit-crds:hover {
  scale: 1.05;
  cursor: pointer;
}

.bnft-img {
  position: absolute;
  top: -13px;
}

.bnft-texts {
  padding: 0 0 0 6.25rem;
}

.bnft-texts h2 {
  font-size: 32px;
  font-weight: 600;
  line-height: 40px;
}

.bnft-texts p {
  font-size: 16px;
  font-weight: 400;
  color: #515151;
  letter-spacing: 0.4px;
}

.migration-procses {
  /* background: url('../../assests/dottedLine.png');
        background-position: center;
        background-repeat: no-repeat; */
  /* background-size: cover; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2rem;
}

.bottomMigra-left {
  height: 28rem;
  width: 10rem;
  position: absolute;
  z-index: -1;
  top: -15rem;
  left: 0;
  background: linear-gradient(
    164deg,
    rgb(232 68 39 / 55%),
    rgb(35 75 153 / 45%)
  );
  filter: blur(160px);
}

.procss-wrapper {
  /* background-image: url('../../assests/dottedLine.png');
    background-repeat: no-repeat;
    background-position: center; */
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 3rem;
}

.procss-cards {
  width: 360px;
  height: -moz-fit-content;
  height: fit-content;
  background-color: #fff;
  border-radius: 20px;
  box-shadow: 0 4px 10px 0 #00000033;
  padding: 35px 25px 10px 25px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1.4rem;
}

.procss-cards:hover {
  scale: 1.05;
  cursor: pointer;
}

.bg-borderDotted {
  width: 100%;
  position: absolute;
  top: 60%;
  display: flex;
  justify-content: center;
}

.bg-borderDotted img {
  max-width: 1300px;
}

.procs-num {
  top: -20px;
}

.procss-cards h4 {
  font-size: 24px;
  font-weight: 600;
  margin: 0;
}

.procss-cards p {
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.4px;
  color: #515151;
  text-align: center;
}
.hrefReadMore{
  text-decoration: none;
}

.eco-card-cnt {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #337ab7;
  color: #fff;
  font-size: 24px;
  font-weight: 500;
}

@media screen and (max-width: 1300px) {
  .border-rht {
    border: none;
  }
}

@media screen and (max-width: 1200px) {
  .bg-borderDotted {
    display: none;
  }
}

@media screen and (max-width: 768px) {
  .procss-wrapper {
    gap: 2rem;
  }
}

@media screen and (max-width: 600px) {
  .token-cards {
    width: 90%;
  }

  .migrationRatio-cards {
    width: 90%;
    padding: 5px 7px;
    border-bottom: 1px dotted black;
  }

  .migrationRatio-cards p{
    color: #515151;
    font-size: 18px;
  }

  .hrefReadMore{
    text-decoration: none;
  }

  .benefit-crds {
    width: 90%;
  }

  .procss-cards {
    width: 90%;
  }

  .migration-section-title {
    font-size: 32px;
    text-align: center;
    line-height: 40px;
  }
  .token-cards h4{
    font-size: 20px;
    font-weight: 600;
    margin: 0;
  }
  .migration-cards-para{
    font-size: 16px;
  }
  .migrationRatio-cards h2{
    font-size: 20px;
    margin: 0;
  }
  .bnft-texts h2{
    font-size: 20px;
  }
  .migration_prcs{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-repeat: no-repeat;
    background-size: contain;
    padding: 1rem 0rem 1rem 0rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Migration/Migration.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mDAAmD;EACnD,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,UAAU;EACV,aAAa;EACb,SAAS;EACT,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE;;uCAEqC;EACrC,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,OAAO;EACP;;;;GAIC;EACD,mBAAmB;AACrB;;AAEA;EACE;;kCAEgC;EAChC,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,wBAAmB;EAAnB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,kCAAkC;EAClC,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,+BAA+B;EACjC;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,yDAAyE;IACzE,4BAA4B;IAC5B,wBAAwB;IACxB,4BAA4B;EAC9B;AACF","sourcesContent":[".migration-wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 1rem;\n  margin-top: 3rem;\n}\n\n.migration-section-title {\n  font-size: 50px;\n  line-height: 80px;\n  font-weight: 700;\n  text-align: center;\n}\n\n.migration-section-para {\n  font-size: 16px;\n  letter-spacing: 0.4px;\n  font-weight: 400;\n  text-align: center;\n}\n\n.token-contain {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 1.5rem;\n  margin-top: 1.5rem;\n}\n\n.token-cards {\n  background: url(\"../../assests/stacking-cards.png\");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  width: 480px;\n  border-radius: 20px;\n  padding: 30px;\n  box-shadow: 0 0 10px 0 #00000033;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.token-cards h4 {\n  font-size: 30px;\n  font-weight: 600;\n  line-height: 40px;\n  color: #234b9a;\n}\n\n.migration-cards-para {\n  font-size: 18px;\n  font-weight: 500;\n  line-height: normal;\n  letter-spacing: 0.4px;\n  color: #515151;\n}\n\n.migration-ratio {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 2rem;\n  margin-top: 3rem;\n}\n\n.migrationRatio-cards {\n  width: 375px;\n  padding: 0 5px;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.border-rht {\n  border-right: 1px dotted #7c7c7c;\n}\n\n.migrationRatio-cards h2 {\n  font-size: 31px;\n  font-weight: 600;\n  line-height: 48px;\n}\n\n.benefit-migra-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  justify-content: center;\n  align-items: center;\n}\n\n.benft-cards-contain {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4rem;\n}\n.benefit-crds {\n  width: 85%;\n  display: flex;\n  gap: 2rem;\n  padding: 16px;\n  box-shadow: 0 0 10px 0 #00000033;\n}\n\n.benefit-crds:hover {\n  scale: 1.05;\n  cursor: pointer;\n}\n\n.bnft-img {\n  position: absolute;\n  top: -13px;\n}\n\n.bnft-texts {\n  padding: 0 0 0 6.25rem;\n}\n\n.bnft-texts h2 {\n  font-size: 32px;\n  font-weight: 600;\n  line-height: 40px;\n}\n\n.bnft-texts p {\n  font-size: 16px;\n  font-weight: 400;\n  color: #515151;\n  letter-spacing: 0.4px;\n}\n\n.migration-procses {\n  /* background: url('../../assests/dottedLine.png');\n        background-position: center;\n        background-repeat: no-repeat; */\n  /* background-size: cover; */\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 2rem;\n}\n\n.bottomMigra-left {\n  height: 28rem;\n  width: 10rem;\n  position: absolute;\n  z-index: -1;\n  top: -15rem;\n  left: 0;\n  background: linear-gradient(\n    164deg,\n    rgb(232 68 39 / 55%),\n    rgb(35 75 153 / 45%)\n  );\n  filter: blur(160px);\n}\n\n.procss-wrapper {\n  /* background-image: url('../../assests/dottedLine.png');\n    background-repeat: no-repeat;\n    background-position: center; */\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 3rem;\n}\n\n.procss-cards {\n  width: 360px;\n  height: fit-content;\n  background-color: #fff;\n  border-radius: 20px;\n  box-shadow: 0 4px 10px 0 #00000033;\n  padding: 35px 25px 10px 25px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 1.4rem;\n}\n\n.procss-cards:hover {\n  scale: 1.05;\n  cursor: pointer;\n}\n\n.bg-borderDotted {\n  width: 100%;\n  position: absolute;\n  top: 60%;\n  display: flex;\n  justify-content: center;\n}\n\n.bg-borderDotted img {\n  max-width: 1300px;\n}\n\n.procs-num {\n  top: -20px;\n}\n\n.procss-cards h4 {\n  font-size: 24px;\n  font-weight: 600;\n  margin: 0;\n}\n\n.procss-cards p {\n  font-size: 14px;\n  font-weight: 400;\n  letter-spacing: 0.4px;\n  color: #515151;\n  text-align: center;\n}\n.hrefReadMore{\n  text-decoration: none;\n}\n\n.eco-card-cnt {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #337ab7;\n  color: #fff;\n  font-size: 24px;\n  font-weight: 500;\n}\n\n@media screen and (max-width: 1300px) {\n  .border-rht {\n    border: none;\n  }\n}\n\n@media screen and (max-width: 1200px) {\n  .bg-borderDotted {\n    display: none;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .procss-wrapper {\n    gap: 2rem;\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .token-cards {\n    width: 90%;\n  }\n\n  .migrationRatio-cards {\n    width: 90%;\n    padding: 5px 7px;\n    border-bottom: 1px dotted black;\n  }\n\n  .migrationRatio-cards p{\n    color: #515151;\n    font-size: 18px;\n  }\n\n  .hrefReadMore{\n    text-decoration: none;\n  }\n\n  .benefit-crds {\n    width: 90%;\n  }\n\n  .procss-cards {\n    width: 90%;\n  }\n\n  .migration-section-title {\n    font-size: 32px;\n    text-align: center;\n    line-height: 40px;\n  }\n  .token-cards h4{\n    font-size: 20px;\n    font-weight: 600;\n    margin: 0;\n  }\n  .migration-cards-para{\n    font-size: 16px;\n  }\n  .migrationRatio-cards h2{\n    font-size: 20px;\n    margin: 0;\n  }\n  .bnft-texts h2{\n    font-size: 20px;\n  }\n  .migration_prcs{\n    background-image: url('../../assests/background-image/migration_pro.png');\n    background-repeat: no-repeat;\n    background-size: contain;\n    padding: 1rem 0rem 1rem 0rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
